import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import PhysicianProfileSidebar from "../Components/PhysicianProfileSidebar";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import { userpatient } from "../Constant/Index";
import { getPhysicianviewperscriptionapi } from "../network/Network";
import { P_HDETAIL } from "../redux/Slices/AuthSlice";
import { useDispatch, useSelector } from "react-redux";

const PhysicianPrescription = () => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state?.Auth?.token);
  const allphysician = useSelector((state) => state?.Auth?.physiciandetail);
  const [userPrescrip, setUserPrescrip] = useState("");

  //   Get Physician Prescription
  useEffect(() => {
    getPhysicianviewperscriptionapi(
      allphysician?.booking_detail?.booking_id,
      token
    ).then((res) => {
      dispatch(P_HDETAIL(res?.data));
      setUserPrescrip(res?.data);
    });
  }, []);
  //   ==================
  return (
    <>
      <Header />
      <PageHeader pagename="Physician Profile" />
      <section className="main-sidebar user-profile">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <PhysicianProfileSidebar />
            </div>
            <div className="col-lg-8">
              <div className="main-profile-content radius-20 p-4">
                <div className="main-headind d-flex align-items-center 	gap-3 mb-3">
                  <div className="edit-btn back">
                    <Link
                      to={`/physician-consultation-detail/${allphysician?.booking_detail?.booking_id}`}
                    >
                      <div className="nav-anchor">
                        <i className="fa-solid fa-arrow-left"></i>
                      </div>
                    </Link>
                  </div>
                  <h5 className="main-heading level-6 main-heading-font dark-color mb-0 wow animate__animated animate__zoomIn animate__delay-1s ">
                    Prescription
                  </h5>
                </div>
                <div className="row">
                  <div className="col-lg-12">
                    <div className="content-qty extra-bg-14 radius-20 p-4 dark-color ">
                      <div className="d-flex gap-3 align-items-center">
                        <img
                          src={
                            allphysician?.patient_detail?.profile_image_url
                              ? allphysician?.patient_detail?.profile_image_url
                              : userpatient
                          }
                          className="img-fluid profie_img"
                          alt=""
                        />
                        <div>
                          <h4 className="main-heading-font level-6 ">
                            {userPrescrip?.patient_detail?.title}
                          </h4>
                          <h5 className="primary-medium-font level-8 extra-color-15">
                            Patient
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-lg-12">
                    <div className="content-qty extra-bg-14 radius-20 p-4 dark-color">
                      <h4 className="main-heading-font level-6 ">
                        Prescription
                      </h4>
                      <p className="extra-color-16">
                        {userPrescrip?.prescription?.detail}
                      </p>
                      {userPrescrip?.prescription?.prescriptions?.map(
                        (item, puindex) => {
                          return (
                            <>
                              <div
                                className="d-flex align-items-center gap-3 mt-2"
                                key={puindex}
                              >
                                <h4 className="extra-color-16 level-7">
                                  {item?.name}
                                </h4>
                                <h4 className="extra-color-16 level-7">
                                  {item?.qty}
                                </h4>
                              </div>
                            </>
                          );
                        }
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default PhysicianPrescription;
